import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=6948fa88&scoped=true&"
import script from "./inputNumber.vue?vue&type=script&lang=js&"
export * from "./inputNumber.vue?vue&type=script&lang=js&"
import style0 from "./inputNumber.vue?vue&type=style&index=0&id=6948fa88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948fa88",
  null
  
)

export default component.exports